import React, { useContext } from 'react';

import { ButtonGroup } from '@atlaskit/button';

import { messages } from '@qality/common-messages';
import { TestExecutionStep, TestStepsView } from '@qality/common-model';
import { TestExecutionPageContext } from '@qality/common-state';

import ChangeView from '../test-case-box/ChangeView';
import GroupStatusSelect from './GroupStatusSelect';
import './_test-execution-details.scss';

type Props = {
  testSteps: Array<TestExecutionStep>;
  onBulkUpdateTestStep: (testSteps: Array<TestExecutionStep>) => Promise<void>;
  numberOfSelectedItems: number;
  view: TestStepsView;
  onChangeView: (value: TestStepsView) => void;
};

function TestExecutionDetailsTableTitles({
  testSteps,
  numberOfSelectedItems,
  onBulkUpdateTestStep,
  view,
  onChangeView,
}: Props): JSX.Element {
  const context = useContext(TestExecutionPageContext);

  return (
    <div className='table-titles'>
      <div className='table-title' style={{ paddingRight: '1em' }}>
        <h4 className='table-title-label'>
          {messages['testExecution.detals.label']}
        </h4>
        <ButtonGroup>
          <ChangeView value={view} onChange={onChangeView} />
        </ButtonGroup>
      </div>
      <div className='table-title' style={{ paddingLeft: '1em', width: '50%' }}>
        <h4 className='table-title-label'>
          {messages['testExecution.results.label']}
        </h4>
        {numberOfSelectedItems > 0 && (
          <GroupStatusSelect
            testSteps={testSteps}
            statuses={context.statuses.allStatuses}
            onBulkUpdateTestStep={onBulkUpdateTestStep}
            numberOfSelectedItems={numberOfSelectedItems}
          />
        )}
      </div>
    </div>
  );
}

export default TestExecutionDetailsTableTitles;
